/* eslint-disable camelcase */
import React, { useEffect, useState } from "react";
import { useTranslation } from "ceco-polyglot";
import { Tab } from "semantic-ui-react";
import RichTextEditor from "react-rte";
import { useDebounce } from "use-debounce";
import { commitMutation } from "react-relay";
import graphql from "babel-plugin-relay/macro";
import environment from "../../environment";
import "./generalInfoTabs.scss";

function GeneralInfoTabs(props) {
  const { faqsContent, privacyContent } = props;
  const [valueFaqs, setValueFaqs] = useState(
    RichTextEditor.createValueFromString(faqsContent.content, "html")
  );
  const [valuePrivacyPolicy, setValuePrivacyPolicy] = useState(
    RichTextEditor.createValueFromString(privacyContent.content, "html")
  );

  const [faqsValueDebounce] = useDebounce(valueFaqs.toString("html"), 500);
  const [privacyValueDebounce] = useDebounce(
    valuePrivacyPolicy.toString("html"),
    500
  );

  const t = useTranslation();

  useEffect(() => {
    const variables = { valueFaqs: faqsValueDebounce };
    commitMutation(environment, {
      mutation: GeneralInfoTabsUpdateFaqsMutation,
      variables,
      onCompleted(response, errors) {
        if (errors) {
        }
      },
      onError(error) {
      },
    });
  }, [faqsValueDebounce]);

  useEffect(() => {
    const variables = {
      valuePrivacy: privacyValueDebounce,
    };
    commitMutation(environment, {
      mutation: GeneralInfoTabsUpdatePrivacyMutation,
      variables,
      onCompleted(response, errors) {
        if (errors) {
        }
      },
      onError(error) {
      },
    });
  }, [privacyValueDebounce]);

  const onChangeFaqs = (value) => {
    setValueFaqs(value);
  };

  const onChangePrivacyPolicy = (value) => {
    setValuePrivacyPolicy(value);
  };

  const panes = [
    {
      menuItem: t("tab.faqs"),
      render: () => (
        <RichTextEditor value={valueFaqs} onChange={onChangeFaqs} />
      ),
    },
    {
      menuItem: t("tab.privacyPolicy"),
      render: () => (
        <RichTextEditor
          value={valuePrivacyPolicy}
          onChange={onChangePrivacyPolicy}
        />
      ),
    },
  ];
  return <Tab menu={{ secondary: true, pointing: true }} panes={panes} />;
}

const GeneralInfoTabsUpdateFaqsMutation = graphql`
  mutation GeneralInfoTabsUpdateFaqsMutation($valueFaqs: String!) {
    staticUrlContent(input: { type: FAQS, content: $valueFaqs, lang: "es" }) {
      file
    }
  }
`;
const GeneralInfoTabsUpdatePrivacyMutation = graphql`
  mutation GeneralInfoTabsUpdatePrivacyMutation($valuePrivacy: String!) {
    staticUrlContent(
      input: { type: PRIVACY, content: $valuePrivacy, lang: "es" }
    ) {
      file
    }
  }
`;
export default GeneralInfoTabs;
